import React, { Component, useState } from 'react'
import s from './Press.module.css'
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react'
import { Keyboard, Mousewheel, Pagination, Autoplay } from 'swiper/modules'
import Image from "next/legacy/image"
import { urlFor } from '@lib/sanity'

export interface IListForm {
  image: any
  title: string
}

export interface PressProps {
  list?: Array<IListForm>
  title?: string,
}

const Press: React.FC<PressProps> = ((props) => {
  const {
    list,
    title
  } = props

  const [swiper, setSwiper] = useState(useSwiper())

  return (
    <div className={s.root}>
      <div className={s.content}>
        <div className={s.inner}>
            <h3 className={`${s.title}`}>{title}
            </h3>
          <div className={''}>
            {list && list?.length > 0 &&
              <Swiper
                cssMode={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                loop={true}
                breakpoints={{
                  // when window width is >= 320px
                  0: {
                    slidesPerView: 1
                  },
                  // when window width is >= 800px
                  800: {
                    slidesPerView: Math.min(list?.length, 2)
                  },
                  // when window width is >= 800px
                  1024: {
                    slidesPerView: Math.min(list?.length, 3)
                  },
                  1600: {
                    slidesPerView: Math.min(list?.length, 4)
                  }
                }}
                mousewheel={true}
                keyboard={true}
                onSwiper={(s: any) => {
                  setSwiper(s)
                }}
                modules={[Mousewheel, Keyboard, Autoplay]}
                className={s.mySwiper}

              >
                {list && list.map((item: any, index: number) => {
                    const imageUrl = urlFor(item.image).url()
                    return <SwiperSlide key={'usp' + index} className={s.swiperSlide}>
                        {item.image && imageUrl &&
                          <div className={'cursor-pointer h-e32 m-space1 relative'}>
                            <Image alt={'Press logo slide' + index} src={imageUrl} layout='fill' objectFit='contain'
                                   objectPosition={'center center'} />
                          </div>}
                        {/*<div className={'text-center text-paragraph03 text-neutral900 block w-full'}>{item.title}</div>*/}
                    </SwiperSlide>
                  }
                )}
              </Swiper>
            }
          </div>
        </div>
      </div>
    </div>
  )
})

export default Press
